import {
  onAuthStateChanged,
  reauthenticateWithCredential,
  signOut,
  updateEmail,
  verifyBeforeUpdateEmail,
} from "firebase/auth";
import { useState, useEffect } from "react";
import { auth, getUser, updateTrabajador, userExists } from "../firebase/firebase";
import { useNavigate } from "react-router-dom";
import logo from "../img/logo.png"
import logo_caritas from "../img/logo_caritas.webp"
import { PROJECT_APP, ECINNOVA, INSERTATOLEDO, CARITASTOLEDO, colorProject } from "./../js/project"
import { EmailAuthProvider } from "firebase/auth/cordova";

export function ChangeEmail() {

  const [user, setUser] = useState(null);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmEmail, setConfirmEmail] = useState("");
  const [mensajeDeAviso, setMensajeDeAviso] = useState("");
  const [stateCambiarEmail, setStateCambiarEmail] = useState(false)
  const navigate = useNavigate();

  useEffect(() => {
    onAuthStateChanged(auth, async (user) => {
      if (user) {
        const isRegistered = await userExists(user.uid);
        if (isRegistered) {
          //TODO: redirigir a Dashboard
          const userDB = await getUser(user.uid)
          setUser(userDB);

          if (userDB.estado === false) { 
            logout()
          }
        } else {
          logout()
        }
      } else {
        navigate("/login")
        // console.log("No hay nadie autenticado ... ");
      }
    });
  }, [navigate]);

  function logout() {
    signOut(auth)
      .then(() => {
        navigate("/login")
      })
      .catch((error) => {
        
      });

    //console.log("OUT");
    //auth().logout();
    //window.location.href = "login.html";
  }

  async function resetPassword() {
    setStateCambiarEmail(true);

    if (email !== confirmEmail) {
      setMensajeDeAviso("Los correos no coinciden");
      setStateCambiarEmail(false);
      return;
    }

    if (email === "") {
      setMensajeDeAviso("El correo está en blanco");
      setStateCambiarEmail(false);
      return;
    }

    try {
      const credential = EmailAuthProvider.credential(
        auth.currentUser.email,
        password
      );

      // Reautenticar al usuario
      await reauthenticateWithCredential(auth.currentUser, credential);

      await verifyBeforeUpdateEmail(auth.currentUser, email);

      setMensajeDeAviso("Te enviamos un enlace al nuevo correo. Revisa tu bandeja de entrada para confirmar el cambio.");

      updateUser();
    } 
    catch (error) {
      if (error.code === "auth/wrong-password") {
        setMensajeDeAviso("La contraseña ingresada es incorrecta");
      } 
      else if (error.code === "auth/requires-recent-login") {
        setMensajeDeAviso("Por seguridad, vuelve a iniciar sesión, accede a este enlace e inténtalo de nuevo");
      } 
      else if (error.code === "auth/email-already-in-use") {
        setMensajeDeAviso("Ese correo ya está en uso por otra cuenta");
      } 
      else if (error.code === "auth/invalid-email") {
        setMensajeDeAviso("El correo ingresado no es válido");
      } 
      else {
        setMensajeDeAviso("Error al cambiar el correo");
      }

      setStateCambiarEmail(false);
    }
  }

  async function updateUser() {
    user.email = email
    await updateTrabajador(user)

    // IMPORTANTE
    // Se le cambia el email al trabajador automaticamente en firestore pero no en authenticator,
    // cuando tenga tiempo lo hago para que todo quede bien y quede todo automatico
    
    // if (user.admin === false) navigate("/controlHorario")
    // else if (user.admin === true) {
    //   if (PROJECT_APP === ECINNOVA || PROJECT_APP === INSERTATOLEDO) {
    //     navigate("/admin")
    //   }
    //   if (PROJECT_APP === CARITASTOLEDO) {
    //     navigate("/controlHorario")
    //   }
    // }
    
  }

  // Comprobación de acceso a resetear el correo abajo en los botones (botones desactivados si no se cumplen las condiciones)
  return (
    <div style={{backgroundColor: colorProject}} className="modal-login">
      <div className="modal-container-login">
        <div className="textcenter">
          { PROJECT_APP === ECINNOVA && 
            <img style={{aspectRatio: "191/140"}} src={logo} width="280px" alt="logo_empresa" />
          }
          { PROJECT_APP === INSERTATOLEDO && 
            <div className="colorred titulo2">INSERTA TOLEDO</div>
          }
          { PROJECT_APP === CARITASTOLEDO && 
            <img style={{aspectRatio: "261/193"}} src={logo_caritas} width="280px" alt="logo_empresa" />
          }
        </div>
        <h1 className="textcenter textbalance" style={{marginBlock: "50px"}}>Cambiar correo electronico</h1>
        
        {/* <form className="formChangePassword" onSubmit={(e) => { e.preventDefault(); resetPassword(); }}> */}
          <label htmlFor="changePassword">Contraseña actual</label>
            <input
              placeholder="Password"
              id="changePassword"
              onChange={(e) => {
                setPassword(e.target.value);
                setMensajeDeAviso("")
              }}
              value={password}
              type="password"
              autoFocus
            />
          <label htmlFor="changePassword">Nuevo correo</label>
            <input
              placeholder="Email"
              id="changePassword"
              onChange={(e) => {
                setEmail(e.target.value);
                setMensajeDeAviso("")
              }}
              value={email}
              type="email"
            />
          <label htmlFor="repeatChangePassword">Repite el correo</label>
            <input
              placeholder="Email"
              id="repeatChangePassword"
              onChange={(e) => {
                setConfirmEmail(e.target.value);
                setMensajeDeAviso("")
              }}
              type="email"
              value={confirmEmail}
            />
          <p className="colorred">{mensajeDeAviso}</p>

          <div className="buttonsBetween">
            {user !== null && user.estado === true &&
              <>
                <button disabled={stateCambiarEmail} onClick={logout} className="cancelButton">Cerrar sesion</button>
                <button disabled={stateCambiarEmail} onClick={resetPassword} className="successButton">Confirmar</button>
              </>
            }
            {(user === null || user.estado !== true) &&
              <>
                <button disabled={true} onClick={logout} className="cancelButton disablebutton">Cerrar sesion</button>
                <button disabled={true} onClick={resetPassword} className="successButton">Confirmar</button>
              </>
            }
          </div>
        {/* </form> */}
      </div>
    </div>
  );
}
